import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const ImageContent = ({ data }) => {
  const { title, imagePosition, image, content, buttons } = data;
  const imageData = getImage(
    image?.localFile?.childImageSharp?.gatsbyImageData
  );
  return (
    <div className="mt-12 flex flex-wrap">
      <div
        className={`w-full basis-full px-4 lg:w-1/2 lg:basis-1/2 lg:px-8 ${
          imagePosition === "left" ? "lg:order-2" : "lg:order-none"
        }`}
      >
        <h2 className="mb-6 font-canossaBd text-lg text-secondary xl:text-2xl 2xl:text-4xl">
          {title}
        </h2>
        <div
          className="mb-6 font-futuraLt text-lg text-bannergrey 2xl:text-xl"
          dangerouslySetInnerHTML={{ __html: content }}
        ></div>
        {buttons?.map((button, index) => (
          <a
            href={button?.buttonData?.url}
            target={button?.buttonData?.target}
            key={index}
            className={`mb-6 inline-block rounded-xl px-12 py-2 text-white transition-all duration-500 lg:mr-4 ${
              button.blueButton
                ? "bg-primary hover:bg-secondary"
                : "bg-secondary hover:bg-primary"
            }`}
          >
            {button?.buttonData?.title}
          </a>
        ))}
      </div>
      {imageData && (
        <div
          className={`w-full basis-full px-4 lg:w-1/2 lg:basis-1/2 ${
            imagePosition === "left" ? "lg:order-1" : "lg:order-none"
          }`}
        >
          <GatsbyImage image={imageData} alt="" />
        </div>
      )}
    </div>
  );
};

export default ImageContent;
